/* ============================================================
   FG Fastbuy — Stockmart 1.0.4 (single-script version)
   ✅ Keeps your cart drawer fix EXACTLY
   + Price updates on variant change
   + Store-specific pickup availability (West Brome / Bedford) via Storefront API storeAvailability.quantityAvailable
   + Shows "Épuisé" + red dot when selected store has 0
   + Robust variant change detection
   + NEW: Cart drawer scroll-unlock guard (prevents “frozen page” after closing drawer)

   IMPORTANT FIXES INCLUDED:
   1) Init guard no longer depends on data-fg-init="1" in markup (prevents script from bailing immediately)
   2) Variant ID detection is scoped to the Fastbuy block’s product section (avoids grabbing the wrong /cart/add form)

   IMPORTANT DEPLOY NOTE:
   - This file must be loaded as an ASSET (eg {{ 'fg-fastbuy.js' | asset_url | script_tag }})
   - Do NOT paste this inside a template where HTML might appear before </script>
   ============================================================ */

(function () {
  'use strict';

  // ------------------------
  // Scroll-lock guard (global, idempotent)
  // ------------------------
  function initCartScrollGuard() {
    if (window.__fgCartScrollGuardInit) return;
    window.__fgCartScrollGuardInit = true;

    function getCartDrawerEl() {
      return (
        document.querySelector('cart-drawer') ||
        document.getElementById('CartDrawer') ||
        document.querySelector('.cart-drawer')
      );
    }

    function cartDrawerLooksOpen(drawer) {
      if (!drawer) return false;

      if (drawer.hasAttribute('open')) return true;
      if (drawer.getAttribute('aria-hidden') === 'false') return true;

      var cls = drawer.classList;
      if (
        cls &&
        (cls.contains('active') ||
          cls.contains('is-open') ||
          cls.contains('open') ||
          cls.contains('drawer--open'))
      )
        return true;

      try {
        var details = drawer.querySelector('details[open]');
        if (details) return true;
      } catch (e) {}

      return false;
    }

    function bodyLooksScrollLocked() {
      var b = document.body;
      var h = document.documentElement;
      if (!b || !h) return false;

      var bcs = b.style;
      var hcs = h.style;
      if (
        (bcs && (bcs.overflow === 'hidden' || bcs.position === 'fixed')) ||
        (hcs && hcs.overflow === 'hidden')
      ) {
        return true;
      }

      var lockClasses = [
        'overflow-hidden',
        'overflow-hidden-tablet',
        'no-scroll',
        'scroll-lock',
        'modal-open',
        'drawer-open',
        'js-drawer-open',
        'prevent-scroll',
        'lock-scroll'
      ];

      for (var i = 0; i < lockClasses.length; i++) {
        if (b.classList.contains(lockClasses[i]) || h.classList.contains(lockClasses[i])) return true;
      }

      return false;
    }

    function forceUnlockScroll() {
      var b = document.body;
      var h = document.documentElement;
      if (!b || !h) return;

      // If theme locked scroll by fixing body and shifting top, restore scroll position.
      try {
        var top = b.style.top;
        var pos = b.style.position;
        if (pos === 'fixed' && top) {
          var y = Math.abs(parseInt(top, 10)) || 0;
          b.style.position = '';
          b.style.top = '';
          b.style.width = '';
          b.style.left = '';
          b.style.right = '';
          window.scrollTo(0, y);
        }
      } catch (e) {}

      b.style.overflow = '';
      h.style.overflow = '';

      var lockClasses = [
        'overflow-hidden',
        'overflow-hidden-tablet',
        'no-scroll',
        'scroll-lock',
        'modal-open',
        'drawer-open',
        'js-drawer-open',
        'prevent-scroll',
        'lock-scroll'
      ];

      for (var i = 0; i < lockClasses.length; i++) {
        b.classList.remove(lockClasses[i]);
        h.classList.remove(lockClasses[i]);
      }
    }

    function checkAndFix() {
      var drawer = getCartDrawerEl();
      var open = cartDrawerLooksOpen(drawer);

      // If drawer is closed but scroll is still locked => unlock.
      if (!open && bodyLooksScrollLocked()) {
        forceUnlockScroll();
      }
    }

    document.addEventListener(
      'click',
      function () {
        setTimeout(checkAndFix, 50);
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (e && (e.key === 'Escape' || e.key === 'Esc')) {
          setTimeout(checkAndFix, 80);
        }
      },
      true
    );

    // Observe class/attribute changes on body + cart drawer
    try {
      var bodyObs = new MutationObserver(function () {
        setTimeout(checkAndFix, 0);
      });
      bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    } catch (e) {}

    function attachDrawerObserver() {
      var drawer = getCartDrawerEl();
      if (!drawer || drawer.__fgObserved) return;
      drawer.__fgObserved = true;

      try {
        var drawerObs = new MutationObserver(function () {
          setTimeout(checkAndFix, 0);
        });
        drawerObs.observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden'] });
      } catch (e) {}
    }

    attachDrawerObserver();
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () {
        attachDrawerObserver();
        checkAndFix();
      }, 120);
    });

    setTimeout(checkAndFix, 250);
  }

  // Initialise guard immediately
  initCartScrollGuard();

  // ------------------------
  // Small helpers
  // ------------------------
  function clampQty(n) {
    var x = parseInt(n, 10);
    if (!x || x < 1) return 1;
    if (x > 99) return 99;
    return x;
  }

  function safeText(el, txt) {
    if (!el) return;
    el.textContent = txt;
  }

  function isFrench() {
    var lang = (document.documentElement.getAttribute('lang') || 'fr').toLowerCase();
    return lang.indexOf('fr') === 0;
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) {}
    var n = (Number(cents) || 0) / 100;
    return n.toLocaleString(undefined, { style: 'currency', currency: 'CAD' });
  }

  // ------------------------
  // Variant id detection (SCOPED + robust)
  // ------------------------
  function getVariantIdFromPageScoped(root, fallback) {
    // 1) Prefer Fastbuy’s hidden variant input (if already set)
    try {
      var fbVariant = root && root.querySelector ? root.querySelector('input[data-fg-variant]') : null;
      if (fbVariant && fbVariant.value && fbVariant.value !== 'NaN') return fbVariant.value;
    } catch (e) {}

    // 2) URL param
    try {
      var u = new URL(window.location.href);
      var v = u.searchParams.get('variant');
      if (v) return v;
    } catch (e) {}

    // 3) Scope to the closest main product section to avoid collisions
    var scope = null;
    try {
      scope = root && root.closest ? root.closest('[id^="MainProduct-"]') || root.closest('section[id]') || document : document;
    } catch (e) {
      scope = document;
    }

    try {
      var scoped = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (scoped && scoped.value) return scoped.value;
    } catch (e) {}

    // 4) Fallback
    return fallback || '';
  }

  // ------------------------
  // Variants JSON (for pricing/compare-at)
  // ------------------------
  function getVariantsJSON() {
    var el = document.querySelector('script[data-fg-fastbuy-variants]') || document.getElementById('fg-fastbuy-variants-json');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function findVariantById(variants, id) {
    if (!variants || !variants.length) return null;
    var sid = String(id || '');
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === sid) return variants[i];
    }
    return null;
  }

  // ------------------------
  // Cart attributes (optional, safe)
  // ------------------------
  function setCartAttributes(fulfilmentProp, store) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          attributes: {
            'FG Fulfilment': fulfilmentProp,
            'FG Preferred store': store
          }
        })
      });
    } catch (e) {}
  }

  // ------------------------
  // Refresh sections: cart-drawer + cart-icon-bubble
  // IMPORTANT: update <cart-drawer> className to flip is-empty
  // ------------------------
  function refreshCartDrawerAndBubble() {
    var url = '/?sections=cart-drawer,cart-icon-bubble&_ts=' + Date.now();

    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Section refresh failed');
        return res.json();
      })
      .then(function (sections) {
        if (sections && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];

          var incomingDrawerEl = tmp.querySelector('cart-drawer');
          var currentDrawerEl = document.querySelector('cart-drawer');

          if (incomingDrawerEl && currentDrawerEl) {
            currentDrawerEl.className = incomingDrawerEl.className;
            currentDrawerEl.innerHTML = incomingDrawerEl.innerHTML;
          }
        }

        if (sections && sections['cart-icon-bubble']) {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = sections['cart-icon-bubble'];

          var incomingBubble = tmp2.querySelector('#cart-icon-bubble');
          var currentBubble = document.getElementById('cart-icon-bubble');

          if (incomingBubble && currentBubble) {
            currentBubble.innerHTML = incomingBubble.innerHTML;
          }
        }

        return new Promise(function (resolve) {
          requestAnimationFrame(function () {
            requestAnimationFrame(resolve);
          });
        });
      })
      .catch(function () {});
  }

  // ------------------------
  // Open Stockmart cart drawer without redirecting to /cart
  // ------------------------
  function openCartDrawerStockmart() {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink) return false;

    var preventNav = function (e) {
      e.preventDefault();
    };
    cartLink.addEventListener('click', preventNav, true);

    try {
      cartLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    } finally {
      cartLink.removeEventListener('click', preventNav, true);
    }

    return true;
  }

  // ------------------------
  // History hook (helps themes using pushState for variants)
  // ------------------------
  if (!window.__fgFastbuyHistoryHooked) {
    window.__fgFastbuyHistoryHooked = true;
    try {
      var _ps = history.pushState;
      history.pushState = function () {
        var r = _ps.apply(this, arguments);
        try {
          document.dispatchEvent(new CustomEvent('fg:variant-maybe-changed'));
        } catch (e) {}
        return r;
      };
      window.addEventListener('popstate', function () {
        try {
          document.dispatchEvent(new CustomEvent('fg:variant-maybe-changed'));
        } catch (e) {}
      });
    } catch (e) {}
  }

  // ------------------------
  // Store availability (Storefront API)
  // ------------------------
  var STOREFRONT_TOKEN = '3c3f77522a32cc4b971f59a2e2d5fab6';
  var API_VERSION = '2026-01';

  function normalise(s) {
    return (s || '').trim().toLowerCase();
  }

  function fetchJsonWithTimeout(url, options, timeoutMs) {
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, timeoutMs);

    return fetch(url, Object.assign({}, options, { signal: controller.signal }))
      .then(function (res) {
        return res.text().then(function (text) {
          return { ok: res.ok, text: text };
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('http');
        if (/^\s*</.test(r.text)) throw new Error('html');
        return JSON.parse(r.text);
      })
      .finally(function () {
        clearTimeout(timer);
      });
  }

  function fetchStoreAvailabilityByVariantId(variantId) {
    var endpoint = window.location.origin + '/api/' + API_VERSION + '/graphql.json';
    var gid = 'gid://shopify/ProductVariant/' + String(variantId);

    var cacheKey = 'fg_sa_' + gid;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        var obj = JSON.parse(cached);
        if (obj && obj.t && Date.now() - obj.t < 30000 && Array.isArray(obj.av)) {
          return Promise.resolve(obj.av);
        }
      }
    } catch (e) {}

    var query =
      '\n' +
      'query($id: ID!) {\n' +
      '  node(id: $id) {\n' +
      '    ... on ProductVariant {\n' +
      '      storeAvailability(first: 50) {\n' +
      '        edges {\n' +
      '          node {\n' +
      '            available\n' +
      '            pickUpTime\n' +
      '            quantityAvailable\n' +
      '            location { name }\n' +
      '          }\n' +
      '        }\n' +
      '      }\n' +
      '    }\n' +
      '  }\n' +
      '}\n';

    return fetchJsonWithTimeout(
      endpoint,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: query, variables: { id: gid } })
      },
      6000
    )
      .then(function (json) {
        if (json && json.errors && json.errors.length) return [];
        var edges =
          json &&
          json.data &&
          json.data.node &&
          json.data.node.storeAvailability &&
          json.data.node.storeAvailability.edges;
        var av = Array.isArray(edges) ? edges.map(function (e) { return e.node; }) : [];
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), av: av }));
        } catch (e) {}
        return av;
      })
      .catch(function () {
        return [];
      });
  }

  // ------------------------
  // Initialise one FG block
  // ------------------------
  function initFastbuy(root) {
    if (!root) return;

    // FIX: Do not rely on markup attributes like data-fg-init="1"
    if (root.__fgInit) return;
    root.__fgInit = true;

    var FR = isFrench();
    var defaultStore = root.getAttribute('data-default-store') || 'West Brome';

    var storeSelect = root.querySelector('[data-fg-store]');
    var qtyInput = root.querySelector('[data-fg-qty]');
    var minusBtn = root.querySelector('[data-fg-minus]');
    var plusBtn = root.querySelector('[data-fg-plus]');

    var form = root.querySelector('[data-fg-form]');
    var atcBtn = root.querySelector('[data-fg-atc]');
    var variantInput = root.querySelector('[data-fg-variant]');
    var propFulfilment = root.querySelector('[data-fg-prop-fulfilment]');
    var propStore = root.querySelector('[data-fg-prop-store]');
    var noteEl = root.querySelector('[data-fg-note]');

    var priceNowEl = root.querySelector('[data-fg-price-now]');
    var priceMetaEl = root.querySelector('[data-fg-price-meta]');
    var priceWasEl = root.querySelector('[data-fg-price-was]');
    var priceSaveEl = root.querySelector('[data-fg-price-save]');

    var dotEl = root.querySelector('[data-fg-dot]');
    var pickupTextEl = root.querySelector('[data-fg-pickuptext]');

    var saveLabel = root.getAttribute('data-save-label') || (FR ? 'Économisez' : 'Save');
    var atcLabel =
      root.getAttribute('data-atc-label') ||
      (atcBtn ? atcBtn.textContent : FR ? 'Ajouter au panier' : 'Add to cart');

    var variants = getVariantsJSON();

    function optionToProperty(opt) {
      if (opt === 'pickup') return 'Pickup';
      if (opt === 'local') return 'Local delivery';
      return 'Shipping';
    }

    function getActiveOption() {
      var active = root.querySelector('.fg-opt.is-active[data-fg-option]');
      return active ? active.getAttribute('data-fg-option') : 'pickup';
    }

    function setActiveOption(opt) {
      var btns = root.querySelectorAll('[data-fg-option]');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var isActive = b.getAttribute('data-fg-option') === opt;
        if (isActive) b.classList.add('is-active');
        else b.classList.remove('is-active');
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    function setQty(n) {
      if (!qtyInput) return;
      qtyInput.value = String(clampQty(n));
    }

    function updatePriceUIByVariantId(id) {
      if (!priceNowEl || !id) return;

      var v = findVariantById(variants, id);
      if (!v) return;

      safeText(priceNowEl, formatMoney(v.price));

      var compare = Number(v.compare_at_price || 0);
      var price = Number(v.price || 0);

      if (priceMetaEl && priceWasEl && priceSaveEl) {
        if (compare > price) {
          priceMetaEl.style.display = '';
          safeText(priceWasEl, formatMoney(compare));
          safeText(priceSaveEl, saveLabel + ' ' + formatMoney(compare - price));
        } else {
          priceMetaEl.style.display = 'none';
          safeText(priceWasEl, '');
          safeText(priceSaveEl, '');
        }
      }
    }

    function setDotState(state) {
      if (!dotEl) return;
      dotEl.classList.remove('fg-dot--loading', 'fg-dot--error');
      if (state === 'loading') dotEl.classList.add('fg-dot--loading');
      if (state === 'bad') dotEl.classList.add('fg-dot--error');
      // "ok" is the default (markup usually has fg-dot--ok)
    }

    function setPickupText(txt) {
      if (!pickupTextEl) return;
      safeText(pickupTextEl, txt);
    }

    function syncVariantId() {
      var id = getVariantIdFromPageScoped(root, variantInput ? variantInput.value : '');
      var num = String(parseInt(id, 10));
      if (variantInput && num && num !== 'NaN') variantInput.value = num;
      return variantInput && variantInput.value && variantInput.value !== 'NaN' ? variantInput.value : '';
    }

    function updatePickupStatusForSelectedStore() {
      var id = syncVariantId();
      if (!id || id === 'NaN') return;

      var store = storeSelect ? storeSelect.value : defaultStore;

      setDotState('loading');
      setPickupText(FR ? 'Disponibilité…' : 'Availability…');

      fetchStoreAvailabilityByVariantId(id).then(function (avails) {
        if (!avails || !avails.length) {
          setDotState('bad');
          setPickupText(FR ? 'Contactez le magasin' : 'Contact store');
          return;
        }

        var match = null;
        for (var i = 0; i < avails.length; i++) {
          var a = avails[i];
          if (normalise(a && a.location && a.location.name) === normalise(store)) {
            match = a;
            break;
          }
        }

        if (!match) {
          setDotState('bad');
          setPickupText(FR ? 'Contactez le magasin' : 'Contact store');
          return;
        }

        var qty = Number(match.quantityAvailable || 0);

        if (qty <= 0) {
          setDotState('bad');
          setPickupText(FR ? 'Épuisé' : 'Sold out');
        } else {
          setDotState('ok');
          setPickupText(FR ? 'Disponible' : 'Available');
        }
      });
    }

    var lastVariantId = '';
    function onVariantMaybeChanged() {
      var id = syncVariantId();
      if (!id || id === 'NaN') return;

      if (id !== lastVariantId) {
        lastVariantId = id;
        updatePriceUIByVariantId(id);
      }
      updatePickupStatusForSelectedStore();
    }

    function setButtonBusy(busy) {
      if (!atcBtn) return;

      if (busy) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-busy', 'true');
        atcBtn.setAttribute('data-original-text', atcBtn.textContent);
        atcBtn.textContent = FR ? 'Ajout…' : 'Adding…';
      } else {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-busy');
        var original = atcBtn.getAttribute('data-original-text');
        atcBtn.textContent = original || atcLabel;
      }
    }

    function applySelection(opt, store) {
      setActiveOption(opt);

      if (storeSelect) storeSelect.value = store;
      if (propStore) propStore.value = store;

      var fulfil = optionToProperty(opt);
      if (propFulfilment) propFulfilment.value = fulfil;

      setCartAttributes(fulfil, store);

      if (noteEl) {
        var label = opt === 'pickup' ? 'Pickup — ' : opt === 'local' ? 'Local delivery — ' : 'Shipping — ';
        safeText(noteEl, label + store);
      }
    }

    if (minusBtn)
      minusBtn.addEventListener('click', function () {
        setQty(clampQty(qtyInput ? qtyInput.value : 1) - 1);
      });

    if (plusBtn)
      plusBtn.addEventListener('click', function () {
        setQty(clampQty(qtyInput ? qtyInput.value : 1) + 1);
      });

    if (qtyInput)
      qtyInput.addEventListener('blur', function () {
        setQty(qtyInput.value);
      });

    var optButtons = root.querySelectorAll('[data-fg-option]');
    for (var i = 0; i < optButtons.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
          applySelection(btn.getAttribute('data-fg-option'), storeSelect ? storeSelect.value : defaultStore);
          updatePickupStatusForSelectedStore();
        });
      })(optButtons[i]);
    }

    if (storeSelect) {
      storeSelect.addEventListener('change', function () {
        applySelection(getActiveOption(), storeSelect.value);
        updatePickupStatusForSelectedStore();
      });
    }

    // Change detection (safe + throttled)
    document.addEventListener('change', function () {
      setTimeout(onVariantMaybeChanged, 30);
    });

    // Lightweight polling as a fallback (60s max)
    var pollCount = 0;
    var pollMax = 240; // ~60s at 250ms
    var poll = setInterval(function () {
      pollCount++;
      onVariantMaybeChanged();
      if (pollCount >= pollMax) clearInterval(poll);
    }, 250);

    // Observe value changes on the *scoped* product form id input (reduces false reads)
    try {
      var scope = root.closest('[id^="MainProduct-"]') || document;
      var themeIdInput = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (themeIdInput) {
        var mo = new MutationObserver(function () {
          onVariantMaybeChanged();
        });
        mo.observe(themeIdInput, { attributes: true, attributeFilter: ['value'] });
      }
    } catch (e) {}

    document.addEventListener('fg:variant-maybe-changed', function () {
      setTimeout(onVariantMaybeChanged, 10);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        syncVariantId();

        var qty = clampQty(qtyInput ? qtyInput.value : 1);
        setQty(qty);

        var idRaw = variantInput ? variantInput.value : '';
        var id = String(parseInt(idRaw, 10));
        if (!id || id === 'NaN') {
          safeText(noteEl, FR ? 'Impossible : variante introuvable.' : 'Could not add: variant not found.');
          return;
        }

        var fulfilmentProp = propFulfilment ? propFulfilment.value : 'Pickup';
        var store = propStore && propStore.value ? propStore.value : defaultStore;

        setCartAttributes(fulfilmentProp, store);

        setButtonBusy(true);
        safeText(noteEl, '');

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(id),
            quantity: qty,
            properties: {
              'FG Fulfilment': fulfilmentProp,
              'FG Preferred store': store
            }
          })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                var msg =
                  err && (err.description || err.message)
                    ? err.description || err.message
                    : FR
                    ? 'Ajout impossible.'
                    : 'Could not add to cart.';
                throw new Error(msg);
              });
            }
            return res.json();
          })
          .then(function () {
            return refreshCartDrawerAndBubble();
          })
          .then(function () {
            openCartDrawerStockmart();

            try {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            } catch (e) {}
            try {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } catch (e) {}

            safeText(noteEl, FR ? 'Ajouté au panier ✓' : 'Added to cart ✓');
          })
          .catch(function (err) {
            safeText(
              noteEl,
              String(
                err && err.message
                  ? err.message
                  : FR
                  ? 'Erreur : ajout impossible.'
                  : 'Error: could not add to cart.'
              )
            );
            try {
              openCartDrawerStockmart();
            } catch (e) {}
          })
          .finally(function () {
            setButtonBusy(false);
          });
      });
    }

    // Init UI defaults
    if (storeSelect) storeSelect.value = defaultStore;
    setQty(1);
    applySelection('pickup', defaultStore);
    onVariantMaybeChanged();
  }

  // ------------------------
  // Boot all FG blocks on page
  // ------------------------
  function boot() {
    var roots = document.querySelectorAll('#fg-fastbuy, [data-fg-root]');
    for (var i = 0; i < roots.length; i++) initFastbuy(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();